// extracted by mini-css-extract-plugin
export default {"icon":"ExpandIcon_icon__P7Z6q","icon_open":"ExpandIcon_icon_open__4AnE6"};